<div class="min-h-screen bg-base-100 pb-16">
  <div class="container mx-auto px-4 pt-8 mb-12">
    <black-stepper [section]="3"></black-stepper>
  </div>

  <div class="container mx-auto px-4 max-w-5xl">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div class="space-y-6">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-success/15 text-success text-3xl">
          <i class="fa-solid fa-circle-check"></i>
        </div>
        <h1 class="text-3xl lg:text-4xl font-extrabold text-base-content tracking-tight">
          You have successfully added your course!
        </h1>
        <p class="text-base text-base-content/70 leading-relaxed">
          @if (isAutoPublishEnabled) {
            Your course is ready to go live. Publish it now to make it available to students, or save it as a draft.
          } @else {
            You can submit your course for review when it's ready, or keep it as a draft until you complete your changes.
          }
        </p>

        <div class="flex flex-col sm:flex-row gap-4 pt-4">
          <button routerLink="/dashboard/courses" class="daisy-btn daisy-btn-outline flex-1">
            Keep as Draft
          </button>
          @if (isAutoPublishEnabled) {
            <button (click)="publishCourse()" class="daisy-btn daisy-btn-primary flex-1">
              Publish Course Now <i class="fa-solid fa-rocket ml-1"></i>
            </button>
          } @else {
            <button (click)="submitForReview()" class="daisy-btn daisy-btn-primary flex-1">
              Submit for Review <i class="fa-solid fa-paper-plane ml-1"></i>
            </button>
          }
        </div>
      </div>

      <div class="flex justify-center">
        @if (createdCourseItem !== null) {
          <div class="w-full max-w-sm">
            <black-ui-card [data]="createdCourseCard"></black-ui-card>
          </div>
        }
      </div>
    </div>
  </div>
</div>
